import {createReducer, on} from "@ngrx/store";
import {
    evaluateRules, evaluateRulesSuccess,
    geoLocateUser,
    geoLocateUserSuccess,
    getMetasInfos,
    getMetasInfosSuccess
} from "./currentPublication.actions";
import {extStorage} from "../ext-profiles/ext-profiles.service";
import {IPublication} from "../publication-access.service";

export interface State {
    uuid: string;
    comId: string;
    infos: IPublication;

    extProfilsNeeded: extStorage;
    all: string[];

    uxInteractions: {
        isLoadingInfos: boolean,
        isLocating: boolean,
    }
}

export const initialState: State = {

    uuid: null,
    comId: null,
    infos: null,

    extProfilsNeeded: null,
    all: [],

    uxInteractions: {
        isLoadingInfos: false,
        isLocating: false,
    }

}


export const reducer = createReducer(
    initialState,

    on(getMetasInfos, (state: State, action) => {
        return {
            ...state,
            uxInteractions: {
                ...state.uxInteractions,
                isLoadingInfos: true,
            },
            uuid: action.pubUuid,

        }
    }),

    on(getMetasInfosSuccess, (state: State, action) => {
        return {
            ...state,
            uxInteractions: {
                ...state.uxInteractions,
                isLoadingInfos: false,
            },

            infos: action.infos,
            extProfilsNeeded: {...action.extProfilsNeeded},

        }
    }),

    on(geoLocateUser, (state: State, action) => {
        return {
            ...state,
            uxInteractions: {
                ...state.uxInteractions,
                isLocating: true,
            },
        }
    }),

    on(geoLocateUserSuccess, (state: State, action) => {
        return {
            ...state,
            uxInteractions: {
                ...state.uxInteractions,
                isLocating: false,
            },
        }
    }),


    on(evaluateRules, (state: State, action) => {
        return {
            ...state,
            uxInteractions: {
                ...state.uxInteractions,
                isLoadingInfos: true,
            },

        }
    }),

    on(evaluateRulesSuccess, (state: State, action) => {
        return {
            ...state,
            uxInteractions: {
                ...state.uxInteractions,
                isLoadingInfos: false,
            },

        }
    }),



//
);
